import { useQuery } from '@tanstack/react-query';
import {
  getPendingInvites,
  GetPendingInvitesResponse,
} from '../api/userManagementApi';
import { useAuthStore } from '../../auth/stores/authStore';
import { userKeys } from './userKeys';

export function usePendingInvites() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery<GetPendingInvitesResponse, Error>({
    queryKey: userKeys.pendingInvites(),
    queryFn: () => getPendingInvites(),
    placeholderData: previousData => previousData,
    enabled: isAuthenticated,
  });
}
